<template>
  <SogCard class="sog-card">
    <SogCardContent>
      <table>
        <tr>
          <td>
            Typ
          </td>
          <td>
            <div v-show="props.person.personType==='Natural'">
              <SogIcon icon="mdi-account" />
              <SogDataLabel value="Natürliche Person" />
            </div>
            <div v-show="props.person.personType==='Legal'">
              <SogIcon icon="mdi-office-building" />
              <SogDataLabel value="Juristische Person" />
            </div>
          </td>
        </tr>
        <tr v-show="props.person.personType==='Natural'">
          <td>
            Vorname
          </td>
          <td>
            <SogDataLabel :value="props.person.name2" />
          </td>
        </tr>
        <tr v-show="props.person.personType==='Natural'">
          <td>
            Nachname
          </td>
          <td>
            <SogDataLabel :value="props.person.name1" />
          </td>
        </tr>
        <tr v-show="props.person.personType==='Legal'">
          <td>
            Firma
          </td>
          <td>
            <SogDataLabel :value="props.person.name1" />
          </td>
        </tr>
        <tr v-show="props.person.personType==='Legal'">
          <td>
            Firmenzusatz
          </td>
          <td>
            <SogDataLabel :value="props.person.name2" />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">
import Person from "@/shared/model/person";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";

interface Props {
  person?:Person
}
const props = withDefaults(defineProps<Props>(), {
    person: undefined
  }
)

</script>

<style scoped>
td{
  padding-right:10px;
}
.sog-card{
  /*
  min-width: 100px;
  width: auto;
  */
  padding-top: 12px;
}

/*.e-card-content{font-size:14px;line-height:1.5;padding:0 18px 12px 18px}
*/
.sog-card{
}
</style>
